import React, { useState, useEffect, useRef, FormEvent } from "react";
import emailjs from "@emailjs/browser";

interface FormData {
  name: string;
  phone: string;
  service: string;
  date: string;
  urgent: string;
}

interface Message {
  type: "bot" | "user";
  text: string;
}

const ChatAssistant: React.FC = () => {
  const [step, setStep] = useState<number>(0);
  const [formData, setFormData] = useState<FormData>({
    name: "",
    phone: "",
    service: "",
    date: "",
    urgent: "",
  });

  const [messages, setMessages] = useState<Message[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);
  const chatEndRef = useRef<HTMLDivElement>(null);

  const questions: string[] = [
    "Hola 👋 Somos fontanería el rápido, para nosotros es un gusto atenderte. para programar una cita contigo ¿podrias decime cual es tu nombre?",
    "Ok, ahora ¿Cual es tu número de teléfono?",
    "¿Quieres explicarme cual es tu problema?",
    "Una cosa mas ¿Cual es tu direccion?",
    "¿Es urgente? (Sí/No)",
  ];

  useEffect(() => {
    if (isOpen && messages.length === 0) {
      setMessages([{ type: "bot", text: questions[0] }]);
    }

    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isOpen]);

  const handleAnswer = (answer: string) => {
    const fields: (keyof FormData)[] = ["name", "phone", "service", "date", "urgent"];

    const currentField = fields[step];

    const updatedData = {
      ...formData,
      [currentField]: answer,
    };

    setFormData(updatedData);

    setMessages((prev) => [...prev, { type: "user", text: answer }]);

    const nextStep = step + 1;

    if (nextStep < questions.length) {
      setStep(nextStep);
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: questions[nextStep] },
      ]);
    } else {
      sendEmail(updatedData);
    }
  };

  const sendEmail = (data: FormData) => {
    emailjs
      .send(
        "service_lznga1w",
        "template_ud3ascb",
        data,
        "97JJNgCPRFssrMbKN"
      )
      .then(
        () =>
          setMessages((prev) => [
            ...prev,
            {
              type: "bot",
              text: "¡Listo tu cita ha sido enviada correctamente! ✅ Te contactaremos lo mas pronto posible 👨‍🔧",
            },
          ]),
        () =>
          setMessages((prev) => [
            ...prev,
            {
              type: "bot",
              text: "Error al enviar 😢 Inténtalo de nuevo.",
            },
          ])
      );
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const answer = inputRef.current?.value.trim();
    if (!answer) return;

    handleAnswer(answer);

    if (inputRef.current) inputRef.current.value = "";
  };

  // 💬 BOTÓN FLOTANTE PRO
  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          padding: "12px 16px",
          borderRadius: "14px",
          background: "linear-gradient(135deg, #ffd54f, #ffb300)",
          color: "#1a1a1a",
          border: "none",
          fontSize: "14px",
          fontWeight: "bold",
          cursor: "pointer",
          zIndex: 9999,
          boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        🤖 Asistente Virtual
      </button>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "350px",
        maxWidth: "90%",
        borderRadius: "12px",
        background: "#fff",
        zIndex: 9999,
        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        fontFamily: "Arial",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#007bff",
          color: "white",
          padding: "10px",
        }}
      >
        <span>Asistente virtual</span>
        <button
          onClick={() => setIsOpen(false)}
          style={{
            background: "linear-gradient(135deg, #ffd54f, #ffb300)",
            border: "none",
            color: "white",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          ✖
        </button>
      </div>

      {/* CHAT */}
      <div
        style={{
          flex: 1,
          padding: "10px",
          maxHeight: "300px",
          overflowY: "auto",
          background: "#f5f5f5",
        }}
      >
        {messages.map((msg, i) => (
          <div
            key={i}
            style={{
              textAlign: msg.type === "bot" ? "left" : "right",
              margin: "6px 0",
            }}
          >
            <span
              style={{
                display: "inline-block",
                padding: "8px 12px",
                borderRadius: "18px",
                background: msg.type === "bot" ? "#e0e0e0" : "#007bff",
                color: msg.type === "bot" ? "#000" : "#fff",
                maxWidth: "80%",
              }}
            >
              {msg.text}
            </span>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      {/* INPUT */}
      {step < questions.length && (
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", borderTop: "1px solid #ddd" }}
        >
          <input
            ref={inputRef}
            type="text"
            placeholder="Escribe aquí..."
            style={{
              flex: 1,
              padding: "10px",
              border: "none",
              outline: "none",
            }}
          />
          <button
            type="submit"
            style={{
              padding: "10px 15px",
              border: "none",
              background: "#007bff",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Enviar
          </button>
        </form>
      )}
    </div>
  );
};

export default ChatAssistant;
